// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"197":"a8bbd0a9","213":"6c665dd3","453":"2c5612e7","455":"39c94b61","606":"32fb7678","617":"6c1f223f"}[chunkId] + ".chunk.js";
};